import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { AppConfigService } from "src/app/app-config.service";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { LookupMedicalCareResponse } from "../../responses/medical-record/lookup-medical-care-response";
import { LookupResponse } from "../../responses/care-line-priority/lookup.response";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";

@Injectable({
    providedIn: 'root'
  })
  export class LookupCareLinePriorityService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
      super(configService);
    }

    public getLookup(): Observable<LookupResponse>{
      let uri = `Lookup`
  
      return this.httpClient.get<LookupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApicareLinePriority) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}